
<div>
  <div class="row">
    <div class="col col-md-4">
      <div :class="{'sr-only': srOnlyLabel}">
        <label :for="$attrs.id" class="a-select-label">Search Groups</label>
      </div>
      <a-select
          :id="$attrs.id"
          :options="options"
          :selectedOptionIds="completerIds"
          bind-by-object
          multiselect
          placeholder="Search to add groups..."
          compress
          @input="createAssignee"
          @destroy="destroyAssignee"
      ></a-select>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <template v-for="permittee in permittees">
        <pill
            :class="$attrs.id"
            :color="pillColor(permittee)"
            @onRemove="removeAssignee(permittee)"
            :value="permittee.display"
        >
          <template #suffix v-if="permittee.legacyConfigTooltip">
            <button type="button" class="btn-icon" v-tooltip="permittee.legacyConfigTooltip">
              <icon class="exclamation"></icon>
              <span class="sr-only">{{ permittee.legacyConfigTooltip }}</span>
            </button>
          </template>
        </pill>
      </template>
    </div>
  </div>
</div>
